var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip-group',{attrs:{"column":""}},_vm._l((_vm.highlightableItems),function(item,idx){return _c('HighlightTagWrapper',{key:idx,attrs:{"data":item.protocol || item.labo}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }